import { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import { FaTimes, FaChevronLeft, FaChevronRight, FaExpand, FaDownload } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";

/* ---------- IMAGE DATA ---------- */

const categories = [
  { label: "All",               slug: "",                                  title: null },
  { label: "Inaugural",         slug: "inaugural",                         title: null },
  { label: "Panel 1",           slug: "sustainable-future",                title: "Scalable Solutions for a Sustainable Future" },
  { label: "Panel 2",           slug: "semiconductor-ecosystem",           title: "Building Bharat's Semiconductor Ecosystem: Design, Fabrication & Talent" },
  { label: "Panel 3",           slug: "startup-nation",                    title: "Startup Nation, Deep Tech Future: Building Scalable Innovation Ecosystems" },
  { label: "Panel 4",           slug: "funding-the-future",                title: "Funding the Future: Corporate India's Role in Research Ecosystems" },
  { label: "Panel 5",           slug: "lab-to-launch",                     title: "Lab to Launch: Translational Tech Startups" },
  { label: "Panel 6",           slug: "skilling-for-the-ai-economy",       title: "Skilling for the AI Economy: What Industry Needs from Academia" },
  { label: "Panel 7",           slug: "reimagining-csr-for-india-future",  title: "Reimagining CSR for India's Future — Partner Showcase" },
  { label: "Social Impact",     slug: "social-impact",                     title: null },
  { label: "Partnership Awards",slug: "partnership-awards",                title: null },
  { label: "Moments",           slug: "moments",                           title: null },
];

const images = [
  // Inaugural
  { src: require("../assets/images/summit/inagural1.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural2.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural3.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural4.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural5.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural6.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural7.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural8.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural9.webp"),  alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural10.webp"), alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural11.webp"), alt: "Inaugural Session",        category: "Inaugural" },
  { src: require("../assets/images/summit/inagural12.webp"), alt: "Inaugural Session",        category: "Inaugural" },

  // Panel 1 — Scalable Solutions
  { src: require("../assets/images/panel1/DSC06933.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC06935.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC06938.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC06940.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC06941.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC07922.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC07923.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC07925.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC07929.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC07930.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },
  { src: require("../assets/images/panel1/DSC07932.webp"), alt: "Scalable Solutions Panel", category: "Panel 1" },

  // Panel 2 — Semiconductor Ecosystem
  { src: require("../assets/images/panel2/DSC06946.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },
  { src: require("../assets/images/panel2/DSC06948.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },
  { src: require("../assets/images/panel2/DSC06951.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },
  { src: require("../assets/images/panel2/DSC06957.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },
  { src: require("../assets/images/panel2/DSC06958.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },
  { src: require("../assets/images/panel2/DSC07963.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },
  { src: require("../assets/images/panel2/DSC07977.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },
  { src: require("../assets/images/panel2/DSC07980.webp"), alt: "Semiconductor Ecosystem Panel", category: "Panel 2" },

  // Panel 3 — Startup Nation
  { src: require("../assets/images/panel3/DSC07033.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07035.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07037.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07038.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07039.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07042.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07044.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07047.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07048.webp"), alt: "Startup Nation Panel", category: "Panel 3" },
  { src: require("../assets/images/panel3/DSC07050.webp"), alt: "Startup Nation Panel", category: "Panel 3" },

  // Panel 4 — Funding the Future
  { src: require("../assets/images/panel4/DSC07085.webp"), alt: "Funding the Future Panel", category: "Panel 4" },
  { src: require("../assets/images/panel4/DSC07086.webp"), alt: "Funding the Future Panel", category: "Panel 4" },
  { src: require("../assets/images/panel4/DSC07087.webp"), alt: "Funding the Future Panel", category: "Panel 4" },
  { src: require("../assets/images/panel4/DSC07090.webp"), alt: "Funding the Future Panel", category: "Panel 4" },
  { src: require("../assets/images/panel4/DSC07093.webp"), alt: "Funding the Future Panel", category: "Panel 4" },
  { src: require("../assets/images/panel4/DSC07098.webp"), alt: "Funding the Future Panel", category: "Panel 4" },
  { src: require("../assets/images/panel4/DSC07101.webp"), alt: "Funding the Future Panel", category: "Panel 4" },
  { src: require("../assets/images/panel4/DSC07112.webp"), alt: "Funding the Future Panel", category: "Panel 4" },

  // Lab to Launch
  { src: require("../assets/images/labtolaunch/DSC07125.webp"), alt: "Lab to Launch", category: "Panel 5" },
  { src: require("../assets/images/labtolaunch/DSC07127.webp"), alt: "Lab to Launch", category: "Panel 5" },
  { src: require("../assets/images/labtolaunch/DSC07130.webp"), alt: "Lab to Launch", category: "Panel 5" },
  { src: require("../assets/images/labtolaunch/DSC07136.webp"), alt: "Lab to Launch", category: "Panel 5" },
  { src: require("../assets/images/labtolaunch/DSC07139.webp"), alt: "Lab to Launch", category: "Panel 5" },
  { src: require("../assets/images/labtolaunch/DSC07144.webp"), alt: "Lab to Launch", category: "Panel 5" },
  { src: require("../assets/images/labtolaunch/DSC08114.webp"), alt: "Lab to Launch", category: "Panel 5" },

  // Panel 5 — Skilling for the AI Economy
  { src: require("../assets/images/panel5/DSC07201 (1).webp"), alt: "Skilling for the AI Economy", category: "Panel 6" },
  { src: require("../assets/images/panel5/DSC07202.webp"),     alt: "Skilling for the AI Economy", category: "Panel 6" },
  { src: require("../assets/images/panel5/DSC07204.webp"),     alt: "Skilling for the AI Economy", category: "Panel 6" },
  { src: require("../assets/images/panel5/DSC07207.webp"),     alt: "Skilling for the AI Economy", category: "Panel 6" },
  { src: require("../assets/images/panel5/DSC07208.webp"),     alt: "Skilling for the AI Economy", category: "Panel 6" },
  { src: require("../assets/images/panel5/DSC07213.webp"),     alt: "Skilling for the AI Economy", category: "Panel 6" },
  { src: require("../assets/images/panel5/DSC07240.webp"),     alt: "Skilling for the AI Economy", category: "Panel 6" },

  // Panel 6 — CSR & Partner Showcase
  { src: require("../assets/images/panel6/DSC07259.webp"), alt: "CSR Partner Showcase", category: "Panel 7" },
  { src: require("../assets/images/panel6/DSC07266.webp"), alt: "CSR Partner Showcase", category: "Panel 7" },
  { src: require("../assets/images/panel6/DSC07272.webp"), alt: "CSR Partner Showcase", category: "Panel 7" },
  { src: require("../assets/images/panel6/DSC07275.webp"), alt: "CSR Partner Showcase", category: "Panel 7" },
  { src: require("../assets/images/panel6/DSC07277.webp"), alt: "CSR Partner Showcase", category: "Panel 7" },
  { src: require("../assets/images/panel6/DSC07282.webp"), alt: "CSR Partner Showcase", category: "Panel 7" },
  { src: require("../assets/images/panel6/DSC07295.webp"), alt: "CSR Partner Showcase", category: "Panel 7" },

  // Tech Showcase
  { src: require("../assets/images/summit/bodhanai.webp"),  alt: "Bodhan AI", category: "Tech Showcase" },
  { src: require("../assets/images/summit/bodhanai1.webp"), alt: "Bodhan AI", category: "Tech Showcase" },

  // Social Impact
  { src: require("../assets/images/summit/socialimpactaward1.webp"),    alt: "Social Impact Award",          category: "Social Impact" },
  { src: require("../assets/images/summit/socialimpactaward2.webp"),    alt: "Social Impact Award",          category: "Social Impact" },
  { src: require("../assets/images/summit/socialimpactaward3.webp"),    alt: "Social Impact Award",          category: "Social Impact" },
  { src: require("../assets/images/summit/socialimpactaward4.webp"),    alt: "Social Impact Award",          category: "Social Impact" },
  { src: require("../assets/images/summit/socialimpact1.webp"),         alt: "Social Impact",                category: "Social Impact" },
  { src: require("../assets/images/summit/socialimpact2.webp"),         alt: "Social Impact",                category: "Social Impact" },
  { src: require("../assets/images/summit/socialimpact3.webp"),         alt: "Social Impact",                category: "Social Impact" },
  { src: require("../assets/images/summit/socialimpact4.webp"),         alt: "Social Impact",                category: "Social Impact" },
  { src: require("../assets/images/summit/Vidyalakshmischolarship.webp"),alt: "Vidyalakshmi Scholarship",     category: "Social Impact" },
  { src: require("../assets/images/summit/ShriSanjayKumarIAS.webp"),    alt: "Shri Sanjay Kumar IAS",        category: "Social Impact" },

  // Partnership Awards
  { src: require("../assets/images/summit/hindalco.webp"),                    alt: "Hindalco",                       category: "Partnership Awards" },
  { src: require("../assets/images/summit/hdfc.webp"),                        alt: "HDFC",                           category: "Partnership Awards" },
  { src: require("../assets/images/summit/amex.webp"),                        alt: "American Express",               category: "Partnership Awards" },
  { src: require("../assets/images/summit/cams.webp"),                        alt: "CAMS",                           category: "Partnership Awards" },
  { src: require("../assets/images/summit/herbalife.webp"),                   alt: "Herbalife",                      category: "Partnership Awards" },
  { src: require("../assets/images/summit/hsbc.webp"),                        alt: "HSBC",                           category: "Partnership Awards" },
  { src: require("../assets/images/summit/mphasis.webp"),                     alt: "Mphasis",                        category: "Partnership Awards" },
  { src: require("../assets/images/summit/ntpc.webp"),                        alt: "NTPC",                           category: "Partnership Awards" },
  { src: require("../assets/images/summit/fedex.webp"),                       alt: "FedEx",                          category: "Partnership Awards" },
  { src: require("../assets/images/summit/coalindia.webp"),                   alt: "Coal India",                     category: "Partnership Awards" },
  { src: require("../assets/images/summit/hyundai82.webp"),                   alt: "Hyundai",                        category: "Partnership Awards" },
  { src: require("../assets/images/summit/hyundai.webp"),                     alt: "Hyundai",                        category: "Partnership Awards" },
  { src: require("../assets/images/summit/idbi.webp"),                        alt: "IDBI",                           category: "Partnership Awards" },
  { src: require("../assets/images/summit/powergrid.webp"),                   alt: "Power Grid",                     category: "Partnership Awards" },
  { src: require("../assets/images/summit/irfc.webp"),                        alt: "IRFC",                           category: "Partnership Awards" },
  { src: require("../assets/images/summit/PowerFinanceCorporationLtd.webp"),  alt: "Power Finance Corporation",      category: "Partnership Awards" },
  { src: require("../assets/images/summit/Premji.webp"),                      alt: "Premji Invest",                  category: "Partnership Awards" },

  // Moments
  { src: require("../assets/images/summit/DSC06957 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07023 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07039 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07058 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07081 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07086 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07122 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07172 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07173 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/DSC07195 (1).webp"),  alt: "Summit Moment", category: "Moments" },
  { src: require("../assets/images/summit/tech-summi.webp"),    alt: "Tech Summit",   category: "Moments" },
];

/* ---------- COMPONENT ---------- */

export default function EventImages() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const activeCat = categories.find((c) => c.slug === (slug || "")) || categories[0];
  const activeCategory = activeCat.label;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const filtered = activeCategory === "All"
    ? images
    : images.filter((img) => img.category === activeCategory);

  const handleTabClick = useCallback((cat) => {
    const path = cat.slug ? `/event-photos/${cat.slug}` : "/event-photos";
    navigate(path);
  }, [navigate]);

  const openLightbox = useCallback((index) => setLightboxIndex(index), []);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);

  const prev = useCallback(() => {
    setLightboxIndex((i) => (i - 1 + filtered.length) % filtered.length);
  }, [filtered.length]);

  const next = useCallback(() => {
    setLightboxIndex((i) => (i + 1) % filtered.length);
  }, [filtered.length]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "ArrowLeft") prev();
    else if (e.key === "ArrowRight") next();
    else if (e.key === "Escape") closeLightbox();
  }, [prev, next, closeLightbox]);

  return (
    <Section id="event-photos">
      <SectionLabel>Gallery</SectionLabel>
      <MainHeading>Event Photos</MainHeading>
      <Divider />
      <Subtitle>
        Relive the highlights from IIT Madras Technology Summit — moments of inspiration,
        collaboration, and recognition.
      </Subtitle>

      {/* Filter Tabs */}
      <FilterBar>
        {categories.map((cat) => (
          <FilterBtn
            key={cat.label}
            active={activeCategory === cat.label}
            onClick={() => handleTabClick(cat)}
          >
            <FilterBtnLabel>{cat.label}</FilterBtnLabel>
          </FilterBtn>
        ))}
      </FilterBar>

      {activeCategory !== "All" && (
        <ActivePanelTitle>{activeCat.title || activeCat.label}</ActivePanelTitle>
      )}

      <ImageCount>{filtered.length} photos</ImageCount>

      {/* Grid */}
      <Grid>
        {filtered.map((img, i) => (
          <GridItem key={`${img.src}-${i}`} onClick={() => openLightbox(i)}>
            <GridImg src={img.src} alt={img.alt} loading="lazy" />
            <Overlay>
              <ExpandIcon><FaExpand /></ExpandIcon>
              <OverlayCaption>{img.alt}</OverlayCaption>
            </Overlay>
          </GridItem>
        ))}
      </Grid>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <Lightbox onKeyDown={handleKeyDown} tabIndex={0} autoFocus>
          <LightboxBackdrop onClick={closeLightbox} />
          <LightboxContent>
            <LightboxTopBar>
              <LightboxClose onClick={closeLightbox}><FaTimes /></LightboxClose>
              <DownloadBtn
                href={filtered[lightboxIndex].src}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaDownload /> Download
              </DownloadBtn>
            </LightboxTopBar>
            <LightboxNav onClick={prev} side="left"><FaChevronLeft /></LightboxNav>
            <LightboxImg
              src={filtered[lightboxIndex].src}
              alt={filtered[lightboxIndex].alt}
            />
            <LightboxNav onClick={next} side="right"><FaChevronRight /></LightboxNav>
            <LightboxFooter>
              <LightboxCaption>{filtered[lightboxIndex].alt}</LightboxCaption>
              <LightboxCounter>{lightboxIndex + 1} / {filtered.length}</LightboxCounter>
            </LightboxFooter>
          </LightboxContent>
        </Lightbox>
      )}
    </Section>
  );
}

/* ---------- STYLES ---------- */

const Section = styled.section`
  width: 100%;
  background: #faf8f5;
  padding: 120px 20px 80px;
  scroll-margin-top: 100px;

  @media (max-width: 768px) {
    padding: 90px 14px 60px;
    scroll-margin-top: 20px;
  }
`;

const SectionLabel = styled.p`
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #d6a54f;
  margin-bottom: 10px;
`;

const MainHeading = styled.h2`
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  color: #791e1b;
  margin: 0 0 4px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 4px;
  background: #d6a54f;
  border-radius: 2px;
  margin: 0 auto 16px;
`;

const Subtitle = styled.p`
  text-align: center;
  max-width: 680px;
  margin: 0 auto 36px;
  font-size: 15px;
  line-height: 1.8;
  color: #4b5563;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 24px;
  }
`;

const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 12px;
`;

const FilterBtn = styled.button`
  padding: 8px 20px;
  border-radius: 30px;
  border: 2px solid ${(p) => (p.active ? "#791e1b" : "#d1d5db")};
  background: ${(p) => (p.active ? "#791e1b" : "#fff")};
  color: ${(p) => (p.active ? "#fff" : "#4b5563")};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;

  &:hover {
    border-color: #791e1b;
    color: ${(p) => (p.active ? "#fff" : "#791e1b")};
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 14px;
  }
`;

const FilterBtnLabel = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
`;

const FilterBtnSub = styled.span`
  font-size: 10px;
  font-weight: 400;
  opacity: 0.8;
  line-height: 1.3;
  max-width: 140px;
  white-space: normal;

  @media (max-width: 768px) {
    max-width: 100px;
    font-size: 9px;
  }
`;

const ActivePanelTitle = styled.h3`
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #171f32;
  margin: 0;
  padding: 20px 24px 8px;

  @media (max-width: 768px) {
    font-size: 17px;
    padding: 16px 16px 6px;
  }
`;

const ImageCount = styled.p`
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
  margin-bottom: 28px;
  font-weight: 500;
`;

const Grid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  columns: 4;
  column-gap: 12px;

  @media (max-width: 1024px) {
    columns: 3;
  }

  @media (max-width: 640px) {
    columns: 2;
    column-gap: 8px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(23, 31, 50, 0.55);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.25s ease;
`;

const ExpandIcon = styled.span`
  color: #fff;
  font-size: 22px;
`;

const OverlayCaption = styled.span`
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 0 12px;
  line-height: 1.4;
`;

const GridItem = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  background: #e5e7eb;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  break-inside: avoid;
  margin-bottom: 12px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.15);
  }

  &:hover ${Overlay} {
    opacity: 1;
  }

  @media (max-width: 640px) {
    margin-bottom: 8px;
  }
`;

const GridImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.35s ease;

  ${GridItem}:hover & {
    transform: scale(1.04);
  }
`;

/* Lightbox */

const Lightbox = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
`;

const LightboxBackdrop = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
`;

const LightboxContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vw;
  max-width: 1100px;
`;

const LightboxImg = styled.img`
  max-width: 100%;
  max-height: 75vh;
  border-radius: 10px;
  object-fit: contain;
  display: block;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
`;

const LightboxTopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
`;

const LightboxClose = styled.button`
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: #791e1b;
  }
`;

const DownloadBtn = styled.a`
  display: flex;
  align-items: center;
  gap: 7px;
  background: #d6a54f;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 18px;
  border-radius: 30px;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: #b8893a;
  }
`;

const LightboxNav = styled.button`
  position: absolute;
  top: 50%;
  ${(p) => (p.side === "left" ? "left: -52px;" : "right: -52px;")}
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: #d6a54f;
  }

  @media (max-width: 768px) {
    ${(p) => (p.side === "left" ? "left: 4px;" : "right: 4px;")}
    top: auto;
    bottom: 60px;
    transform: none;
  }
`;

const LightboxFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 14px;
  padding: 0 4px;
`;

const LightboxCaption = styled.span`
  font-size: 14px;
  color: #e5e7eb;
  font-weight: 500;
`;

const LightboxCounter = styled.span`
  font-size: 13px;
  color: #d6a54f;
  font-weight: 700;
`;
